import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[evkMatDisplay1]'
})
export class MatDisplay1Directive {

    @HostBinding('class')
    public class = 'mat-display-1';

    @HostBinding('style.margin')
    public margin = 0;

}
